import dayjs from 'dayjs';

export const getValidatePeriodFunc = (
  fieldValue: string,
  errorMessage: string,
): ((value: string) => boolean | string) => {
  return value => {
    if (fieldValue && !value) {
      return errorMessage;
    }

    return true;
  };
};

export const fixPrecision = (value: number): number => Math.round(value * 100) / 100;

export const camelCaseToTitleCase = (field: string | undefined) => {
  if (!field) return '';
  return field
    .replace(/([A-Z])/g, ' $1')
    .replace(/^./, str => str.toUpperCase())
    .trim();
};

const DOMAIN_ACRONYMS = ['DIP', 'BTL', 'FIS'];

export const allCapsToTitleCase = (field: string | undefined) => {
  if (!field) return '';
  return field
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, str => str.toUpperCase())
    .split(' ')
    .map(word => (DOMAIN_ACRONYMS.includes(word.toUpperCase()) ? word.toUpperCase() : word))
    .join(' ')
    .trim();
};

export const prettifyEnum = (enumValue: string | undefined): string => {
  if (!enumValue) return '';
  return enumValue
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, str => str.toUpperCase())
    .split(' ')
    .map(word => (DOMAIN_ACRONYMS.includes(word.toUpperCase()) ? word.toUpperCase() : word))
    .join(' ')
    .trim();
};

export const prettifyErrors = (errors: Record<string, string[]> | string[], fieldsToSkip: string[]): string[][] => {
  if (!errors) {
    return [];
  }

  const errClone = JSON.parse(JSON.stringify(errors));

  fieldsToSkip.forEach(field => {
    delete errClone[field];
  });

  if (Object.keys(errClone).length === 0) {
    return [];
  }

  if (Array.isArray(errClone)) {
    return errClone.map(errorArr => errorArr.missingFields.map(camelCaseToTitleCase));
  }
  if (typeof errClone === 'object') {
    return [errClone.missingFields.map(camelCaseToTitleCase)];
  }
  return [];
};

export const isRetiringWithinTenYears = (dateOfBirth: Date, retirementAge: number): boolean => {
  if (!dateOfBirth || !retirementAge) return false;
  const retirementDate = dayjs(dateOfBirth).add(retirementAge, 'year');
  const tenYearsFromNow = dayjs().add(10, 'year');
  return retirementDate.isBefore(tenYearsFromNow);
};
